function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M5.45934 10.9844C5.3976 10.9071 5.36887 10.8086 5.3794 10.7103C5.38994 10.612 5.43888 10.5218 5.51559 10.4594C5.55309 10.4219 6.53746 9.65313 8.09371 9.25938C9.64996 8.86563 11.7687 8.80938 14.2062 10.4406C15.9687 11.6125 17.8156 11.9781 19.6906 11.5188C20.5257 11.316 21.3146 10.9565 22.0156 10.4594C22.0934 10.4078 22.1877 10.3872 22.28 10.4014C22.3723 10.4157 22.4559 10.4639 22.5146 10.5366C22.5732 10.6093 22.6026 10.7013 22.597 10.7945C22.5914 10.8877 22.5512 10.9755 22.4843 11.0406C22.4468 11.0781 21.4625 11.8469 19.9062 12.2406C19.3325 12.3822 18.744 12.4546 18.1531 12.4563C16.8968 12.4563 15.3875 12.1281 13.7937 11.0594C12.0312 9.88751 10.1843 9.52188 8.30934 9.98126C7.47426 10.184 6.68529 10.5435 5.98434 11.0406C5.90709 11.1024 5.80858 11.1311 5.71026 11.1206C5.61193 11.11 5.52175 11.0611 5.45934 10.9844ZM22.0156 15.7094C21.3146 16.2065 20.5257 16.566 19.6906 16.7688C17.8156 17.2281 15.9687 16.8625 14.2062 15.6906C11.7687 14.0594 9.53746 14.1531 8.09371 14.5094C6.64996 14.8656 5.55309 15.6719 5.51559 15.7094C5.47206 15.7382 5.43504 15.7758 5.40688 15.8198C5.37872 15.8637 5.36006 15.9131 5.35207 15.9647C5.34408 16.0163 5.34696 16.0689 5.36051 16.1194C5.37406 16.1698 5.39798 16.2168 5.43075 16.2574C5.46352 16.2981 5.50442 16.3314 5.55082 16.3553C5.59722 16.3793 5.6481 16.3932 5.70021 16.3964C5.75232 16.3995 5.80451 16.3917 5.85343 16.3735C5.90236 16.3553 5.94694 16.3271 5.98434 16.2906C6.68529 15.7935 7.47426 15.434 8.30934 15.2313C10.1843 14.7719 12.0312 15.1375 13.7937 16.3094C15.3875 17.3781 16.8968 17.7063 18.1531 17.7063C18.744 17.7046 19.3325 17.6322 19.9062 17.4906C21.4625 17.0969 22.4468 16.3281 22.4843 16.2906C22.5512 16.2255 22.5914 16.1377 22.597 16.0445C22.6026 15.9513 22.5732 15.8593 22.5146 15.7866C22.4559 15.7139 22.3723 15.6657 22.28 15.6514C22.1877 15.6372 22.0934 15.6578 22.0156 15.7094ZM22.0156 20.9594C21.3146 21.4565 20.5257 21.816 19.6906 22.0188C17.8156 22.4781 15.9687 22.1125 14.2062 20.9406C11.7687 19.3094 9.53746 19.4031 8.09371 19.7594C6.64996 20.1156 5.55309 20.9219 5.51559 20.9594C5.4487 21.0245 5.40853 21.1123 5.40294 21.2055C5.39735 21.2988 5.42674 21.3907 5.48536 21.4634C5.54398 21.5361 5.62762 21.5843 5.7199 21.5986C5.81219 21.6129 5.90648 21.5922 5.98434 21.5406C6.68529 21.0435 7.47426 20.684 8.30934 20.4813C10.1843 20.0219 12.0312 20.3875 13.7937 21.5594C15.3875 22.6281 16.8968 22.9563 18.1531 22.9563C18.744 22.9546 19.3325 22.8822 19.9062 22.7406C21.4625 22.3469 22.4468 21.5781 22.4843 21.5406C22.5512 21.4755 22.5914 21.3877 22.597 21.2945C22.6026 21.2013 22.5732 21.1093 22.5146 21.0366C22.4559 20.9639 22.3723 20.9157 22.28 20.9014C22.1877 20.8872 22.0934 20.9078 22.0156 20.9594Z",
  fill: "#4285F4"
});

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  x: 0.375,
  y: 0.375,
  width: 3.25,
  height: 19.25,
  rx: 1.625,
  fill: "white",
  stroke: "#4285F4",
  strokeWidth: 0.75
});

var _ref4 = /*#__PURE__*/React.createElement("line", {
  y1: 2.75,
  x2: 2,
  y2: 2.75,
  stroke: "#4285F4",
  strokeWidth: 0.5
});

var _ref5 = /*#__PURE__*/React.createElement("line", {
  y1: 11.75,
  x2: 2,
  y2: 11.75,
  stroke: "#4285F4",
  strokeWidth: 0.5
});

var _ref6 = /*#__PURE__*/React.createElement("line", {
  y1: 5.75,
  x2: 2,
  y2: 5.75,
  stroke: "#4285F4",
  strokeWidth: 0.5
});

var _ref7 = /*#__PURE__*/React.createElement("line", {
  y1: 14.75,
  x2: 2,
  y2: 14.75,
  stroke: "#4285F4",
  strokeWidth: 0.5
});

var _ref8 = /*#__PURE__*/React.createElement("line", {
  y1: 8.75,
  x2: 3,
  y2: 8.75,
  stroke: "#4285F4",
  strokeWidth: 0.5
});

var _ref9 = /*#__PURE__*/React.createElement("line", {
  y1: 17.75,
  x2: 3,
  y2: 17.75,
  stroke: "#4285F4",
  strokeWidth: 0.5
});

function SvgMucNuocSong(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 28,
    viewBox: "0 0 26 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMucNuocSong);
export default __webpack_public_path__ + "static/media/muc_nuoc_song.b7b53fc5.svg";
export { ForwardRef as ReactComponent };